import { FormDateFieldPlugin } from './FormDateFieldPlugin';
import { FormFilePlugin } from './FormFilePlugin';
import { FormHtmlPlugin } from './FormHtmlPlugin';
import { FormMultiSelectPlugin } from './FormMultiSelectPlugin';
import { FormNumberFieldPlugin } from './FormNumberFieldPlugin';
import { FormRadioGroupPlugin } from './FormRadioGroupPlugin';
import { FormSelectFieldPlugin } from './FormSelectFieldPlugin';
import { FormSliderPlugin } from './FormSliderPlugin';
import { FormTextFieldPlugin } from './FormTextFieldPlugin';
import { FormTimeFieldPlugin } from './FormTimeFieldPlugin';
import { FormYesNoPlugin } from './FormYesNoPlugin';
export const defaultFormElementPlugins = [
    FormTextFieldPlugin,
    FormNumberFieldPlugin,
    { type: '', divider: true },
    FormRadioGroupPlugin,
    FormYesNoPlugin,
    FormMultiSelectPlugin,
    FormSelectFieldPlugin,
    FormSliderPlugin,
    FormDateFieldPlugin,
    FormTimeFieldPlugin,
    FormFilePlugin,
    { type: '', divider: true },
    FormHtmlPlugin
];
//# sourceMappingURL=default.js.map